module.exports = {
  renderer: [ 'type', require(4) ],
  pathMap: [ 'type', require(5) ]
};